import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule, formatDate } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { CommunityService } from '../../../services/community.service';
import { ActivatedRoute } from '@angular/router';
import { PostStoreService } from '../home/postService/post-store.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../guards/service/auth.service';
import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
type DurationUnit = 'days' | 'weeks' | 'months';
@Component({
  selector: 'app-create-post',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './create-post.component.html',
  styleUrls: ['./create-post.component.css'],
})
export class CreatePostComponent {
  @Input() profilePhoto: any; 
  @Input() IsRecruiter: boolean = false;
   @Input() isKARecruiter: boolean = false;
  
  @Output() postCreated = new EventEmitter<void>(); 

  @ViewChild('imageModal') imageModalTemplate!: TemplateRef<any>;
  imageModalRef?: NgbModalRef;

  postForm: FormGroup;
  jobPostForm!: FormGroup;
  selectedImages: File[] = [];
  imagePreviews: string[] = [];
  imageLoading: boolean[] = [];

  imageError = '';
  showModal = false;
  isSubmitting = false;
  isFadingOut = false;
  communityId!: number;

  imageViewer: { list: string[]; current: string; index: number } | null = null;
  showJobPostModal: boolean = false;
  isPostFadingOut: boolean = false;
  durationNumbers = Array.from({ length: 36 }, (_, i) => i + 1);

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private communityService: CommunityService,
    private route: ActivatedRoute,
    private postStore: PostStoreService,
    private modal: NgbModal,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
  ) {
    this.postForm = this.fb.group({
      content: ['', [Validators.required, Validators.maxLength(1000)]],
    });
  this.jobPostForm = this.fb.group({
  designation: ['', [Validators.required, this.noUrlsEmailsValidator]],
  description: ['', [this.noUrlsEmailsValidator]],
  location: ['', Validators.required],
  start_date: ['', Validators.required],
  duration_value: [null, [Validators.required, Validators.min(1)]],
  duration_unit: ['', [Validators.required]],
});


    this.route.params.subscribe((params) => {
      this.communityId = +params['communityId'];
    });
  }
// job post starts 

// Blocks URLs/domains/emails in text fields
private noUrlsEmailsValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const v = (control.value ?? '').toString();
  if (!v) return null;
  const emailRe  = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;
  const urlRe    = /(https?:\/\/|www\.)\S+/i;
  const domainRe = /\b([a-z0-9-]+\.)+[a-z]{2,}\b/i;
  return (emailRe.test(v) || urlRe.test(v) || domainRe.test(v)) ? { hasUrlEmail: true } : null;
};

 openJobPostModal() {
    this.showJobPostModal = true;
    this.isPostFadingOut = false;
  }

  closeJobPostModal() {
    this.isPostFadingOut = true;
    setTimeout(() => {
      this.showJobPostModal = false;
      this.jobPostForm.reset();
      this.isPostFadingOut = false;
    }, 300);
  }
submitJobPost(): void {
  if (this.jobPostForm.invalid) {
    this.jobPostForm.markAllAsTouched();
    return;
  }

  const raw = this.jobPostForm.value;

  const designation = (raw.designation || '').toString().trim();
  const description = (raw.description || '').toString().trim();
  const location    = (raw.location || '').toString().trim();

  // Build "duration" from dropdowns: e.g., "1 week", "3 months"
  const dVal  = Number(raw.duration_value) || 0;
  const dUnit = (raw.duration_unit || '').toString().trim(); // 'days' | 'weeks' | 'months'
  const singularUnitMap: Record<string, string> = { days: 'day', weeks: 'week', months: 'month' };
  const duration = dVal > 0 && dUnit
    ? `${dVal} ${dVal === 1 ? (singularUnitMap[dUnit] || dUnit) : dUnit}`
    : '';

  const start = raw.start_date
    ? formatDate(raw.start_date as string, 'mediumDate', 'en-US')
    : '';

  const lines = [
    `Job Title: ${designation}`,
    description ? `Description: ${description}` : null,
    `Location: ${location}`,
    `Start Date: ${start}`,
    `Duration: ${duration}`
  ].filter(Boolean) as string[];

  const compiled = lines.join('\n');

  if (compiled.length > 1000) {
    this.toastr.error(`Content is ${compiled.length} chars (max 1000). Please shorten the description.`);
    return;
  }

  this.postForm.patchValue({ content: compiled });

  // reset images just like before
  this.selectedImages = [];
  this.imagePreviews = [];
  this.imageLoading = [];

  this.submitPost('job');
}



  // post starts
  openModal() {
    this.showModal = true;
    this.isFadingOut = false;
  }

  closeModal() {
    this.isFadingOut = true;
    setTimeout(() => {
      this.showModal = false;
      this.postForm.reset();
      this.selectedImages = [];
      this.imagePreviews = [];
      this.imageLoading = [];
      this.imageError = '';
      this.imageViewer = null;
      this.isFadingOut = false;
    }, 300);
  }

  onFileChange(event: any) {
    const files = Array.from(event.target.files) as File[];
    const availableSlots = 5 - this.selectedImages.length;

    if (files.length > availableSlots) {
      this.toastr.warning(`You can only upload ${availableSlots} more image(s).`);
      files.splice(availableSlots);
    }

    for (const file of files) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.onload = () => {
          if (img.width > 4096 || img.height > 4096) {
            this.toastr.error(`${file.name} exceeds max resolution`);
            return;
          }

          const finalize = (finalFile: File) => {
            this.selectedImages.push(finalFile);
            this.createPreview(finalFile);
          };

          if (img.width > 1024) {
            const canvas = document.createElement('canvas');
            const ratio = img.height / img.width;
            canvas.width = 1024;
            canvas.height = 1024 * ratio;
            const ctx = canvas.getContext('2d');
            ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);
            canvas.toBlob((blob) => {
              if (blob) {
                const resizedFile = new File([blob], file.name, { type: file.type });
                finalize(resizedFile);
              }
            }, file.type);
          } else {
            finalize(file);
          }
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }

    event.target.value = '';
  }

  createPreview(file: File) {
    const reader = new FileReader();
    const index = this.imagePreviews.length;
    this.imageLoading[index] = true;

    reader.onload = (e: any) => {
      this.imagePreviews.push(e.target.result);
      this.imageLoading[index] = false;
      this.cdr.detectChanges(); // force update
    };

    reader.readAsDataURL(file);
  }

  openImageViewer(images: string[], index: number): void {
    this.imageViewer = {
      list: images,
      current: images[index],
      index,
    };
    this.imageModalRef = this.modal.open(this.imageModalTemplate, { size: 'lg', centered: true });
  }

  hasNext(): boolean {
    return !!this.imageViewer && this.imageViewer.index < this.imageViewer.list.length - 1;
  }

  hasPrev(): boolean {
    return !!this.imageViewer && this.imageViewer.index > 0;
  }

  nextImage(): void {
    if (this.hasNext()) {
      this.imageViewer!.index += 1;
      this.imageViewer!.current = this.imageViewer!.list[this.imageViewer!.index];
    }
  }

  prevImage(): void {
    if (this.hasPrev()) {
      this.imageViewer!.index -= 1;
      this.imageViewer!.current = this.imageViewer!.list[this.imageViewer!.index];
    }
  }

  onContentInput() {
    const content = this.postForm.value.content;
    if (content && content.length >= 1000) {
      this.toastr.warning('Maximum of 1000 characters reached');
    }
  }

submitPost(postType: 'post' | 'job' = 'post') {
  const content = this.postForm.value.content?.trim() || '';
  const hasContent = content.length > 0;
  const hasImages = this.selectedImages.length > 0;

  if (!hasContent && !hasImages) {
    this.toastr.warning('Please add some content or upload an image');
    return;
  }
  if (this.isSubmitting || !this.communityId) return;

  this.isSubmitting = true;

  const fd = new FormData();
  fd.append('content', content);
  fd.append('post_type', postType);            // <-- NEW
  this.selectedImages.forEach((img) => fd.append('files', img));

  const queryParams = { bucket: 'Community/post-attachments' };

  this.communityService.createPost(this.communityId, fd, queryParams).subscribe({
    next: (res) => {
      const newPost = res?.data?.data?.post;
      if (newPost) {
        this.postStore.addPost({
          ...newPost,
          replies: [],
          showReplies: false,
          repliesLoaded: false,
        });
      }
      this.toastr.success('Post created successfully!');
      this.postCreated.emit();
      this.closeAnyPostModal();
    },
    error: (err) => {
      const payload = err?.error?.error || err?.error || {};
      const msg = payload.description || 'Failed to create post.';
      this.toastr.error(msg);
      this.isSubmitting = false;
      if (msg === 'Your account has been suspended.') this.onLogout();
    },
    complete: () => { this.isSubmitting = false; },
  });
}

  removeImage(index: number): void {
    this.selectedImages.splice(index, 1);
    this.imagePreviews.splice(index, 1);
    this.imageLoading.splice(index, 1);
    this.cdr.detectChanges();
  }
  onLogout(): void {
    this.authService.handleLogout();
  }

private closeAnyPostModal(): void {
  // Close the regular post modal if open
  if (this.showModal) {
    this.closeModal();
    return;
  }
  // Close the job post modal if open
  if (this.showJobPostModal) {
    this.closeJobPostModal();
  }
}
}
